<div class="overflow-x-auto w-full mt-2 ">
    <table class="table table-auto w-full ">
        <!-- head -->
        <thead>
            <tr>
                @for (i of data.label; track $index) {
                <th>{{i}}</th>
                }
            </tr>
        </thead>
        <tbody>
            <!-- row 1 -->
            @for (i of data.data; track $index) {
            <tr>
                @for (j of i; track $index) {

                <td>{{j}}</td>
                }

            </tr>
            }
        </tbody>
    </table>
</div>